import type { PublicKey } from "@solana/web3.js";
import { useMemo } from "react";

import { useAccountsContext } from "../../contexts/accounts";

export const useAccountByMint = (mint?: string | PublicKey) => {
  const { userTokenAccounts, userTokenAccountsMap } = useAccountsContext();
  const account = useMemo(() => {
    if (userTokenAccounts.length) {
      const mintAddress = typeof mint === "string" ? mint : mint?.toBase58();
      const index = mintAddress ? userTokenAccountsMap[mintAddress] : -1;
      return index >= 0 ? userTokenAccounts[index] : undefined;
    }
  }, [userTokenAccounts, mint, userTokenAccountsMap]);
  return account;
};
